import { useCallback } from "react";
import { fetchProject, updateProject } from "../api/projectService";

export const useProjectLocationAction = (projectId) => {
    const fetchProjectLocation = useCallback(async () => {
        try {
            const project = await fetchProject(projectId);
            return {
                latitude: project.latitude || "",
                longitude: project.longitude || "",
                zoom: project.zoom || 15
            };
        } catch (error) {
            console.error("プロジェクト位置情報の取得に失敗:", error);
            throw new Error("プロジェクトの取得に失敗しました");
        }
    }, [projectId]);

    const updateProjectLocation = useCallback(async (latitude, longitude, zoom) => {
        try {
            if (!latitude || !longitude || !zoom) {
                throw new Error("位置情報が不完全です");
            }

            return await updateProject(projectId, { latitude, longitude, zoom });
        } catch (error) {
            console.error("プロジェクト位置情報の更新に失敗:", error);
            throw new Error("更新に失敗しました");
        }
    }, [projectId]);

    return { fetchProjectLocation, updateProjectLocation };
};